import React, { Component } from "react";
import { Divider, Breadcrumb, Container } from "semantic-ui-react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { SyncLoader } from "react-spinners";

import {
  FIND_CLUB_ROUTE,
  HOME_ROUTE,
  CLUBS_ROUTE,
  BASE_URL
} from "../../constants/route.constants";
import { APP_NAME } from "../../constants/resource.constants";
import ClubList from "../../components/ClubList/ClubList";
import { getParsedRouteParam, capitaliseFirstLetters } from "../../utility";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class Home extends Component {
  componentWillMount() {
    const country = getParsedRouteParam(this.props.match.params.country);
    const state = getParsedRouteParam(this.props.match.params.state);

    this.setState({
      country,
      state
    });

    this.props.requestClubs({
      query: {
        country: { $regex: country, $options: "i" },
        state: { $regex: state, $options: "i" }
      }
    });
    this.findClubs = this.findClubs.bind(this);
  }

  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  findClubs() {
    const clubs = this.props.clubs;

    const stateClubs = _.filter(clubs, club => {
      return (
        club.state.toLowerCase() === this.state.state.toLowerCase() &&
        club.country.toLowerCase() === this.state.country.toLowerCase()
      );
    });
    return stateClubs;
  }

  render() {
    const countryLabel = capitaliseFirstLetters(this.state.country);
    const stateLabel = capitaliseFirstLetters(this.state.state);

    const description = `Browse all GAA clubs in ${stateLabel}, ${countryLabel}.`;

    return (
      <div className="page__outer-container">
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          <Helmet>
            <title>
              {stateLabel} | {APP_NAME}
            </title>
            <meta name="description" content={description} />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta property="og:title" content={`${stateLabel} | ${APP_NAME}`} />
            <meta property="og:description" content={description} />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
          </Helmet>
          <h1 className="capitalize">{this.state.state}</h1>
          <Breadcrumb size="small">
            <Breadcrumb.Section href={HOME_ROUTE}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section href={FIND_CLUB_ROUTE}>
              Find a club
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section
              href={`${CLUBS_ROUTE}/${this.props.match.params.country}`}
            >
              {countryLabel}
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section active>{stateLabel}</Breadcrumb.Section>
          </Breadcrumb>
          <Divider />
          <div className="page__outer">
            {this.props.clubs.length > 0 ? (
              <ClubList
                clubs={this.findClubs()}
                row="4"
                history={this.props.history}
              />
            ) : (
              <div className="spinner__container">
                <SyncLoader loading={true} margin="7px" color="#007849" />
              </div>
            )}
          </div>
        </Container>
        <Footer />
      </div>
    );
  }
}

Home.defaultProps = {
  requestClubs: () => ({}),
  clubs: []
};

Home.propTypes = {
  requestClubs: PropTypes.func,
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  history: PropTypes.shape({
    push: PropTypes.func
  })
};



// WEBPACK FOOTER //
// ./src/routes/Clubs/View.js